import React from "react";
import {
  ControlBar,
  ForwardControl,
  PlaybackRateMenuButton,
  ReplayControl,
  VolumeMenuButton,
} from "video-react";
import "video-react/dist/video-react.css"; // Import the CSS
import { StyledPlayer } from "./style";
export default function ReactPlayerCm({ poster, src }) {
  return (
    <StyledPlayer autoPlay={false} poster={poster} src={src}>
      <ControlBar>
        <ReplayControl seconds={10} order={1.1} />
        <ForwardControl seconds={30} order={1.2} />
        <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} order={7.1} />
        <VolumeMenuButton disabled />
      </ControlBar>
    </StyledPlayer>
  );
}
